import { MessageCircle } from "lucide-react";

export default function WhatsAppFab() {
  return (
    <a
      data-testid="whatsapp-fab"
      href="https://wa.me/393389472101?text=Salve%2C%20vorrei%20richiedere%20un%20preventivo%20per%20valutazione%20di%20oro%2Fargento."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-40 flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-[#25D366] hover:bg-[#1ebe57] shadow-2xl shadow-green-900/40 hover:scale-[1.03] transition-all"
      aria-label="Richiedi preventivo WhatsApp"
    >
      <MessageCircle size={22} className="text-white shrink-0" />
      <span className="text-white text-sm font-semibold tracking-wide whitespace-nowrap">Richiedi Preventivo</span>
    </a>
  );
}
